import { useState, useRef, useEffect } from "react";
import { Play, Pause } from "lucide-react";

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const sectionRef = useRef(null);

  const handlePlayPause = () => {
    if (!videoRef.current) return;

    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
    } else {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  // 🎯 Autoplay on scroll
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!videoRef.current) return;

        if (entry.isIntersecting) {
          videoRef.current.play();
          setIsPlaying(true);
        } else {
          videoRef.current.pause();
          setIsPlaying(false);
        }
      },
      { threshold: 0.6 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="group relative min-h-[40svh] md:min-h-[100svh] overflow-hidden bg-[#F9F9EB]"
    >
      {/* Background Video */}
      <video
        ref={videoRef}
        className="absolute inset-0 w-full h-full md:object-cover"
        muted
        playsInline
        loop
      >
        <source src="/video.mp4" type="video/mp4" />
      </video>

      {/* Gradient Overlay */}
      {/* <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/60"></div> */}

      {/* Center Play Button (hidden by default) */}
      <div className="absolute inset-0 z-20 flex items-center justify-center pointer-events-none">
        <button
          onClick={handlePlayPause}
          className="pointer-events-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300
                     relative w-10 h-10 bg-white/20 backdrop-blur-md rounded-full
                     flex items-center justify-center hover:bg-white/30
                     border border-white/40"
        >
          {isPlaying ? (
            <Pause className="w-5 h-5 text-white" />
          ) : (
            <Play className="w-5 h-5 text-white ml-1" />
          )}

          {!isPlaying && (
            <span className="absolute inset-0 rounded-full border border-white/50 animate-ping"></span>
          )}
        </button>
      </div>
    </section>
  );
};

export default VideoSection;
